export default __webpack_public_path__ + "static/scroll_phone_5-10881a27304410c674110fd63a6b54e8.png";